import DOMPurify from "dompurify";

/**
 * Sanitizes HTML content to prevent XSS attacks while preserving safe HTML tags.
 * Uses DOMPurify to clean the HTML before rendering with dangerouslySetInnerHTML.
 *
 * @param dirty - The potentially unsafe HTML string to sanitize
 * @returns A sanitized HTML string safe for use with dangerouslySetInnerHTML
 */
export const sanitizeHtml = (dirty: string | null | undefined): string => {
    if (!dirty) {
        return "";
    }
    return DOMPurify.sanitize(dirty, {
        // Allow common HTML tags
        ALLOWED_TAGS: [
            "p",
            "br",
            "strong",
            "em",
            "u",
            "b",
            "i",
            "ul",
            "ol",
            "li",
            "a",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "div",
            "span",
            "blockquote",
            "code",
            "pre",
        ],
        // Allow common attributes
        ALLOWED_ATTR: ["href", "target", "rel", "class", "id", "style"],
        // Allow data URIs for images if needed (can be removed if not needed)
        ALLOW_DATA_ATTR: false,
    });
};
